import React from 'react';
import { BlockWithImage, Fact, FactsContainer, JoinUs, PageTitle, Section, Seo, TeamMember } from '../components/ui';
import lang from '../assets/lang';

export const About = () => {

	const getAbouts = () =>
		lang.abouts.map((about, index) =>
			<BlockWithImage
				key={about.title}
				title={about.title}
				text={about.text}
				image={about.image}
				pull={index % 2 === 0} />
		);

	const getFacts = () =>
		lang.facts.map(fact =>
			<Fact
				key={fact.title}
				title={fact.title}
				count={fact.count}
				symbol={fact.symbol} />
		);

	const getTeam = () =>
		lang.team.map(member =>
			<TeamMember
				key={member.name}
				name={member.name}
				job={member.job}
				image={member.image}
				socialLinks={member.socialLinks} />
		);

	return (
		<div>
			<Seo
				pageTitle={lang.aboutSeo.pageTitle}
				metaDescription={lang.aboutSeo.metaDescription}
				metaKeywords={lang.aboutSeo.metaKeywords}
			/>
			<PageTitle
				title={lang.titleAboutUs}
				text={lang.textAboutUs} />

			<Section
				sectionClass='mb-300'
				title={lang.titleAboutUsPage}
				text={lang.textAboutUsPage}>

				{getAbouts()}
			</Section>

			<FactsContainer>
				{getFacts()}
			</FactsContainer>

			{/*<TeamContainer*/}
			{/*	title={lang.titleTeam}>*/}

			{/*	{getTeam()}*/}
			{/*</TeamContainer>*/}

			<JoinUs
				title={lang.titleJoinUs}
				text={lang.textJoinUs}
				buttonText={lang.buttonTextJoinUs}
				link={lang.buttonLinkJoinUs} />
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/pages/About.js